// extracted by mini-css-extract-plugin
var _1 = "HNCq2Ym02tKqB8o7w28s";
export { _1 as "version" }
